export default "__VITE_PUBLIC_ASSET__b247f3dc__"